import React from 'react';

const SectionDivider = () => {
  return (
    <div className="w-full flex justify-center py-12 opacity-40">
      <div className="h-px w-24 bg-[#D9CCBA]"></div>
      <div className="mx-4 w-1.5 h-1.5 rounded-full bg-[#D9CCBA]"></div>
      <div className="h-px w-24 bg-[#D9CCBA]"></div>
    </div>
  );
};

export default SectionDivider;